import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconXBrandedLight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconXBrandedLight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bf7cc6b3cbc89e3f221da1610fb2ae802597104f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fcfe133dc57d33c99c361b4149c3a639bab23942', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f1e3166fc96c0d62271aa218e097fe2d029bc4a2', d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121z", fill: "#fff" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-x-branded-light", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-x-branded-light"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-x-branded-light":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconXBrandedLight$1);
            }
            break;
    } });
}

const CosmosIconXBrandedLight = CosmosIconXBrandedLight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconXBrandedLight, defineCustomElement };
